import PublicLayout from "../layouts/PublicLayout.svelte";
import AdminLayout from "../layouts/AdminLayout.svelte";
import Welcome from "../components/Welcome.svelte";
import Loading from "../components/Loading.svelte";
import SignIn from "../pages/auth/SignIn.svelte";
import ForgotPassword from "../pages/auth/ForgotPassword.svelte";
import DecksList from "../pages/deck/DecksList.svelte";
import Deck from "../pages/deck/Deck.svelte";
import Languages from "../pages/languages/Languages.svelte";
import Translations from "../pages/translation/Translations.svelte";
import UsersList from "../pages/user/UsersList.svelte";
import Settings from "../pages/Settings.svelte"
import UserProfile from "../pages/user/UserProfile.svelte";
import InAppAdsList from "../pages/InAppAdsList.svelte";
import InAppAd from "../pages/InAppAd.svelte";
import { user, userProfile } from "../store/auth.js";
import Support from "../pages/Support.svelte"

function userIsAdmin() {
  var is = false;
  try {
    userProfile.subscribe(u => {
      if (u) is = u.role == "admin" ? true : false;
    });
  } catch (error) { }
  return is;
}

const routes = [
  {
    name: "/",
    component: Loading,
    layout: PublicLayout
  },
  {
    name: "login",
    component: SignIn,
    layout: PublicLayout,
  },
  {
    name: "forgot-password",
    layout: PublicLayout,
    component: ForgotPassword,
  },

  {
    name: "support",
    component: Support,
    layout: PublicLayout,
  },

  {
    name: "admin",
    component: AdminLayout,
    nestedRoutes: [
      {
        name: "index",
        component: Welcome
      },
      {
        name: "langs",
        onlyIf: { guard: userIsAdmin, redirect: "/admin" },
        component: Languages
      },
      {
        name: "translations",
        component: Translations
      },
      {
        name: "users",
        component: UsersList,
        onlyIf: { guard: userIsAdmin, redirect: "/admin" }
      },
      {
        name: "users/:uid",
        component: UserProfile
      },
      {
        name: "settings",
        component: Settings,
        onlyIf: { guard: userIsAdmin, redirect: "/admin" }
      },
      {
        name: "in-app-ads",
        component: InAppAdsList,
        onlyIf: { guard: userIsAdmin, redirect: "/admin" }
      },
      {
        name: "in-app-ads/:id",
        component: InAppAd,
        onlyIf: { guard: userIsAdmin, redirect: "/admin" }
      },
      {
        name: "country/:countryId/:lang",
        nestedRoutes: [
          {
            name: "decks",
            component: DecksList
          },
          {
            name: "decks/:deck",
            component: Deck
          }
        ]
      }
    ]
  }
];

export { routes };
